import {  ReactNode, useEffect, useRef, useState } from "react";
import  {Range} from "quill";

import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { UploadImage, ValidateImageDimensions } from "./Utilities/FileUploadUtility";
import { AlertConfirm } from "./ConfirmationPopups";
import FileUpload from "components/Controls/FileUpload";
import ReactDOM, { createPortal } from "react-dom";

import Quill from 'quill';
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";

import "../Style/Blogging.scss";
import { SiteData } from "./Data/SiteData";
import UnsplashMenu, { UnplashCreditImageDownload, UnsplashImageSearch } from "./UnsplashMenu";

import { BoldIcon, IndentIcon, ItalicIcon, LinkIcon, OLIcon, OutdentIcon, StrikeThroughIcon, ULIcon, UnderlineIcon } from "./InlineTextEditor";
import HoverToolTip from "./HoverToolTip";
import DeleteIcon from "./Icons/DeleteIcon";
import { TextAlignCenter, TextAlignLeft, TextAlignRight } from "./Icons/AlignmentIcons";
import { ClosestWithClass } from "vagaro-website-rendering/src/components/Utilities/HTMLHelpers";

import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import DOMPurify from "dompurify";

import CustomColorPicker from "./StyleInputs/CustomColorPicker";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import SelectDropdown from "./SelectDropdown";
import { AITones, BlogAIFormat } from "./Utilities/AIHandler";
import { blogPlaceHolderText, editTextPlaceHolder } from "./Data/WBComponentDefaults";
import { PoweredByUnsplash, UnsplashIcon } from "./StyleInputs/ImageField";
import { AILoader, AILoaderFinish } from "./Menus/AILoader";
import { useSelector } from "react-redux";
import { EditorMode } from "./WebDesigner";
import Loader from "components/Common/Loader";





const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
const loadingGif = `${process.env.PUBLIC_URL}/other/ImageLoadingGif.gif`;
const notFoundImage ='https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc…cf2.rackcdn.com/Websitebuilder/20240826214558.png';
enum BlogEditorState{
    Editing,
    AddingImage,
    UpdatingImage,
    EditingImage,
    AddingLink,
    PickingColor,
    PromptingAI,

}



  const Inline = Quill.import('blots/inline') as any;





  const Align = Quill.import('formats/align') as any;

  Quill.register(Align, true);

  class CustomClassBlot extends Inline {
    static create(value:any) {
      let node = super.create();
      node.setAttribute('class', value); // Assign the class directly
      return node;
    }

    static formats(node:any) {
      return node.getAttribute('class'); // Return the class attribute
    }

    format(name:any, value:any) {
      if (name === 'cClass' && value) {
        this.domNode.setAttribute('class', value); // Set class if the format name matches
      } else {
        super.format(name, value);
      }
    }
  }


  CustomClassBlot.blotName = 'cClass';
  CustomClassBlot.tagName = 'span';

  Quill.register(CustomClassBlot);

  class HighlightBlot extends Inline {

        static create(value:any) {

        let node = super.create();
        if(value)
        node.classList.add("quill-selected");

        return node;

      }

      static formats(node:any) {

        return node.classList.contains('quill-selected');
      }

      format(name:any, value:any) {


        if (name === 'highlight') {
          // Toggle the class based on value
          if (value) {
            this.domNode.classList.add('quill-selected');
          } else {
            this.domNode.classList.remove('quill-selected');

            if (this.domNode.classList.length === 0) {
                if(this.domNode.parentElement){

                    while(this.domNode.firstChild){
                    this.domNode.parentElement.appendChild(this.domNode.firstChild);
                    }
                    if(this.domNode.firstChild)
                    this.domNode.remove();
                }
              }
          }
        }
      }


}
HighlightBlot.blotName = 'highlight';
HighlightBlot.tagName = 'span';
Quill.register('formats/highlight',HighlightBlot);


const Clipboard = Quill.import('modules/clipboard') as any;

class CustomClipboard extends Clipboard {
    onPaste(rng:any,txt:any) {


    const range = rng;//this.quill.getSelection();
    const text = txt.text;//(e.originalEvent || e).clipboardData.getData('text/plain');

    const html =  DOMPurify.sanitize(txt.html.replace(/style="([^"]*?)background-color:[^;]+;([^"]*?)"/g, 'style="$1$2"')); // remove all bg styling

    this.quill.deleteText(range.index, range.length);

    if (html) {
      // Insert HTML without sanitization
      this.quill.clipboard.dangerouslyPasteHTML(range.index, html);
    } else {
      // Fallback to plain text if no HTML
      this.quill.insertText(range.index, text);
    }

    this.quill.setSelection(range.index + text.length);
  }
}

// Register the custom clipboard module
Quill.register('modules/clipboard', CustomClipboard);

const BlockEmbed = Quill.import('blots/block/embed') as any;

class CustomHTMLBlot extends BlockEmbed {
  static create(value:any) {
    let node = super.create();
    // Add custom HTML structure
    node.setAttribute('contenteditable', 'false'); // Prevent editing
    node.innerHTML = value;
    return node;

  }

  static value(node:any) {
    return node.innerHTML;
  }

  static formats() {
    return false; // Block formats like bold/italic inside this block
  }

}

CustomHTMLBlot.blotName = 'customHTML';
CustomHTMLBlot.tagName = 'div'; // Use a block element
CustomHTMLBlot.className = 'custom-html-block'; // Optional: Add class for styling

Quill.register(CustomHTMLBlot);


export function InlineTextEditorWrapper ({userContext, node,dom,siteData,context}:{userContext:UserContext,node?:LayoutNode,dom:HTMLElement, siteData:SiteData,context:UserContext}) {



    const useFullOptions = node?.typename == wBComponentTypeNames.richText;
   document.body.style.overflow = "hidden";
    const [update, setUpdate] = useState(false);

    const forceUpdate = ()=>{
        setUpdate(!update);
    }

    const createQuill = ()=>{

        dom.style.position = "relative"; // make relative to make sure absolute positioned highlihgt works correctly
        //stash existing alt tags before quill strips them
        let imgs = dom.querySelectorAll("img");
        let alts:string[] = [];
        let imgClasses:string[] = [];
        imgs.forEach((img:HTMLImageElement)=>{

            alts.push(img.alt);
            imgClasses.push(img.className);
        });
        savedAlts.current = alts;
        savedImgClasses.current = imgClasses;
        return new Quill(dom as HTMLElement,   {modules: {

            clipboard: {

                matchVisual: false,

              },
                   /* The following allows for using backspace when editing text. See https://github.com/quilljs/quill/issues/2167 */
            keyboard: { bindings: { list: { key: 'backspace', context: { format: ['list'] }, handler: function (range:any, context:any) { if (range.length === 0 && range.index !== 0) { editor.deleteText(range.index - 1, 1); } else { editor.deleteText(range.index,range.length); } } } } }
          }})
    }

    const savedAlts = useRef<string[]>([]);
    const savedImgClasses = useRef<string[]>([]);



    useEffect(()=>{


        //reapply all alt tags after quill strips them
        let afterImages = dom.querySelectorAll("img");

        for(let i = 0;i<savedAlts.current.length&&i<afterImages.length;i++){
            afterImages[i].alt = savedAlts.current[i];
            afterImages[i].className = savedImgClasses.current[i];
        }

        //delte the place holder text when first clicking in
        if(dom.textContent == editTextPlaceHolder || dom.textContent == blogPlaceHolderText){
            editor.deleteText(0, editor.getLength())

        }

//eslint-disable-next-line
    },[]);
    dom.innerHTML = node?.content??"";

    const editor=  createQuill();



    return <>

    <InlineTextEditorFull updateWrapper={forceUpdate} userContext={userContext} editor={editor} node={node} dom={dom} siteData={siteData} context={context} fullOptions={useFullOptions}/></>

}

export function InlineTextEditorFull ({updateWrapper,userContext,editor,node,dom,siteData,context,fullOptions}:{updateWrapper:Function,userContext:UserContext,editor:Quill,node?:LayoutNode,dom:HTMLElement, siteData:SiteData,context:UserContext,fullOptions?:boolean}) {


    const { BusinessGroup, CountryID, BusinessName } = useSelector((state: any) => state.Business);

    const includeLinking:boolean = node?.typename!=wBComponentTypeNames.button;



    const scrollRef = useRef<HTMLElement>(document.getElementById("v-canvas")??document.body);
    const scrollPoint = useRef<number>(0);

    const clickIndexRef = useRef<number>(0);
    const imgDom = useRef<HTMLImageElement|null>(null);
    const linkDom = useRef<HTMLAnchorElement|null>(null);
    const colorRef = useRef<HTMLDivElement|null>(null);
    const [formats, setFormats] = useState<any>({});

    const handleSelectionChange = (range:any, oldRange:any, source:any) => {
        if (range) {
          updateFormats(range);
        }
      };

    const updateFormats = (range?:any)=>{
        if(!range)
            range = editor.getSelection();
        if(range){
            const format =  editor.getFormat(range);
            setFormats(format);
        }
    }

    function quillGetHTML(inputDelta:any) {

        var tempCont = document.createElement("div");
        (new Quill(tempCont)).setContents(inputDelta);
        return tempCont.getElementsByClassName("ql-editor")[0].innerHTML;
    }

    const [isLoading, setIsLoading] = useState(false);
    const [nomralLoading,setNomralLoading] = useState(false);
    const [loadComplete,setLoadComplete] = useState(false);
    const [editorState, realSetEditorState] = useState<BlogEditorState>(BlogEditorState.Editing);

    const setEditorState = (state:BlogEditorState)=>{

        saveScroll();
        realSetEditorState(state);
        loadScroll();
    }
    // const [currentSelection, setCurrentSelection] = useState<Range>(null);
    const currentSelectionRef = useRef<Range | null>(null);


    const saveScroll = ()=>{
        scrollPoint.current = scrollRef.current.scrollTop;
    }
    const loadScroll = ()=>{
        scrollRef.current.scrollTop = scrollPoint.current;
    }

    const SaveSelection = ()=>{

                let range = editor.getSelection();
                currentSelectionRef.current = range;

    }

    const insertImage = (url:string)=>{

            if(currentSelectionRef.current){
             let select = currentSelectionRef.current;
             editor.insertEmbed(select.index, 'image', url);//insert the image
             editor.setSelection(select.index+1,0);//focus in front of the image
             editor.insertText(select.index+1, '\n');//add a new line
             editor.setSelection(select.index+2,0);//focus after the new line
             currentSelectionRef.current = editor.getSelection();
             setTimeout(()=>{
                editor.focus();

             },10);
            }



    }

    useEffect(()=>{
        saveScroll();
        editor.focus();
        if(node?.content&&node.content.length<10) //dont select all long text
            editor.setSelection(0,10000);
        loadScroll();
        //eslint-disable-next-line
    },[]);



    const creditAttribute = "data-credit";
    const creditLinkAttribute = "data-link";

    const checkImgSrcs = (images:HTMLImageElement[],onFinish:()=>void=()=>{})=>{

        const promiseList:any = [];
        const creditPormises:any = [];
        images.forEach((img:HTMLImageElement)=>{

            let desc = img.alt;
            img.src = loadingGif;
            if(desc&&desc.length > 0){
                //remove unnecessary words as it affects the search results
                desc = desc.replace("image","").replace("photo","").replace("picture","").replace("photograph","");

                promiseList.push(
                UnsplashImageSearch(userContext,desc,1,(data)=>{

                    //@TODO, just using image url breaks Unsplash TOS, need to show photographer credit
                    if(data?.data?.results?.length>0){
                        let results = data.data.results;

                        //tall images don't look great on blog posts so filter to wide images
                        let newResults = results.filter((result:any)=>(result.width>result.height));


                        if(newResults.length==0){
                            img.src = notFoundImage;
                        }
                        //fall back to any images if possible
                        if(newResults.length>0)
                            results = newResults;

                        let random = results[Math.floor(Math.random()*results.length)];
                        if(random){
                            let url = random.urls.regular;
                            let user = random.user.name;
                            img.setAttribute(creditAttribute,user);
                            img.setAttribute(creditLinkAttribute,random.links.html);
                            img.src = url;

                            creditPormises.push(
                                UnplashCreditImageDownload(userContext,random.links.download_location)
                            );

                        }
                        else{
                            //img.src = can't find image
                        }



                    }

                },(data)=>{
                    AlertConfirm("Oops! Something went wrong finding an image. Please try again later.");
                    img.src = "";

                })
            )


            }

        });

        Promise.all(promiseList).then(()=>{

          Promise.all(creditPormises).then(()=>{
            addImageCredit(images);


          });

        });


    }

    function moveImagesOutsideHeadings(htmlString:string) {
        // Parse the HTML string into a DOM structure
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Select all heading tags (h1 to h6)
        const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

        headings.forEach(heading => {
          const images = heading.querySelectorAll('img'); // Find images inside the heading

          images.forEach(img => {
            // Insert the image before the heading
            if(heading.parentNode)
                heading.parentNode.insertBefore(img, heading);
          });
        });

        // Serialize the modified DOM structure back into an HTML string
        return doc.body.innerHTML;
      }

    const spaceHeadingsAndImagesFromRawHTML = (html:string)=>{
        let newHTML = html;

        newHTML = html.replaceAll("\n","<br>");//replace new lines with breaks
        //remove any leading h1 tags and set the title of the blog post to the first h1 tag
        if(newHTML.startsWith("<h1>")){
            let index = newHTML.indexOf("</h1>");
            let header = newHTML.substring(0,index+5).replaceAll("<h1>","").replaceAll("</h1>","");
            let txtArea = document.getElementById("blog-heading-input");
            if(txtArea){

                let txt = txtArea as HTMLTextAreaElement;

                if(!txt.value||txt.value.length == 0||txt.value == editTextPlaceHolder || txt.value == blogPlaceHolderText){
                    txt.value = header;
                    txt.click();// fire the even hooked up to the textarea to update the title
                }
            }


            newHTML = newHTML.substring(index+5);
        }


        newHTML = html.replaceAll("\n","<br>");

        newHTML = html.replaceAll("<li><br></li>","");//remove empty list items

        newHTML = moveImagesOutsideHeadings(newHTML);

    ;



     newHTML = newHTML
    // Add a <br> before each heading if it's not already there
    .replace(/(<h[1-6]>)/g, '<br>$1')
    // Add a <br> after each heading if it's not already there
    .replace(/(<\/h[1-6]>)/g, '$1<br>')
    // Add a <br> before and after each <p><img /></p> block
    .replace(/(<img[^>]*>)/g, '<br><p class="ql-align-center">$1</p>');



    newHTML = newHTML.replaceAll('\n','')
    .replaceAll('<p class="ql-align-center"><br></p>','<br>')
    .replaceAll('</li><br>','')
    .replaceAll('<p><br></p>','<br>')
    .replaceAll('<p>&nbsp;</p>','<br>')
    .replaceAll("<br><br>","<br>")
    .replaceAll("<br><br>","<br>");//remove duplicates

    if(newHTML.startsWith("<br>"))
        newHTML = newHTML.substring(4);


    return newHTML;

    }


    const addImageCredit=(imgs:HTMLImageElement[])=>{



        imgs.forEach((img:HTMLImageElement)=>{

            let credit = img.getAttribute(creditAttribute);
            let link = img.getAttribute(creditLinkAttribute);
            if(credit){


            let find = Quill.find(img);

            let index = find?editor.getIndex(find as any):0;
            clickIndexRef.current = index;
            img.removeAttribute("data-credit");
            editor.clipboard.dangerouslyPasteHTML(index+2,`<p class="ql-align-center"><i>Photo by <a target='_blank' href='${link}'>${credit}</a> on Unsplash</i></p><br>`);

            }
        })


    }

    const rewriteSelectedContent = (tone:string,prompt:string)=>{


        if(node){

            let portal = dom.querySelector('.highlight-portal');
            if(portal){
                (portal as HTMLElement).style.display = "none";
            }
            let content = dom.innerHTML;

            //let sanatizedContent =  content//.replace(/style="[^"]*"/g, ''); // remove all font coloring (may need to update with more cases as they are found)

                let sanatizedContent = content
                  .replace('contenteditable="true"', "")
                  .replace("ql-editor", "");


            node.content = sanatizedContent;

            if(portal){
                (portal as HTMLElement).style.display = "block";
            }

        }

        if(siteData.designer){
            siteData.designer.saveUndoState();
        }

        let imgData:{url:string,alt:string,class:string}[] = [];

        let imgs = dom.querySelectorAll("img");

        imgs.forEach((img:HTMLImageElement)=>{
            imgData.push({url:img.src,alt:img.alt,class:img.className});

        });


        setIsLoading(true);
        setLoadComplete(false);
        if(currentSelectionRef.current){
            saveScroll();

           editor.setSelection(currentSelectionRef.current);
           loadScroll();


        let delta = editor.getContents(currentSelectionRef.current.index,currentSelectionRef.current.length);

        let html = quillGetHTML(delta);
        if(html == "<p><br></p>")
            html = ""; // ignore a single empty paragraph please

        let textContent = dom.textContent?.trim()??"";
        let des = siteData.designer;
        let rew = false;
        if(des?.state.mode != EditorMode.Blogging){
            rew = true;
        }
        BlogAIFormat(html.length>1||textContent.length>2|| rew, html,tone,prompt,BusinessGroup,CountryID,BusinessName, userContext, (result:string)=>{


            if(result.includes("```html")){ // remove gpt garbage

                result = result.split("```html").pop()??"";
                result = result.split("```").shift()??"";
            }

            result = DOMPurify.sanitize(result);

            result = spaceHeadingsAndImagesFromRawHTML(result);

            editor.setSelection(currentSelectionRef.current?.index??0,currentSelectionRef.current?.length??0);

            editor.deleteText(currentSelectionRef.current?.index??0,currentSelectionRef.current?.length??0);

            if(result.includes("<img")&&!result.includes("src")){ // edge case where images don't have a source
                result = result.replaceAll("<img","<img src='"+loadingGif+"'");//add loading gif to images without src
            }

            editor.clipboard.dangerouslyPasteHTML(currentSelectionRef.current?.index??0,result);


            let newImgs = dom.querySelectorAll("img");

            let newURls:HTMLImageElement[] = []; // check if AI added new image urls, validate and replace with correct content if possible
            for(let i = 0;i<newImgs.length;i++){
                let d = imgData.find((img)=>img.url == newImgs[i].src);
                if(d){
                    d.url = "found";//mark url as already being found so if multiple it will skip to the next one
                    newImgs[i].alt = d.alt;
                    newImgs[i].className = d.class;
                }
                else{

                    newURls.push(newImgs[i]);
                }

            }



            checkImgSrcs(newURls,()=>{

                if((window as any).saveUndoState){
                    (window as any).saveUndoState();
                }

            });

            setIsLoading(false);
            setLoadComplete(true);

            setTimeout(()=>{setLoadComplete(false)},1000);

        },(err:any)=>{


            AlertConfirm("Oops! Something went wrong. Please try again later.");
            setIsLoading(false);
        });

    }

    }

    useEffect(()=>{
        editor.on('selection-change', handleSelectionChange);
        editor.on('text-change', () => {


            if(node)
                node.content = editor.root.innerHTML;
        });
//eslint-disable-next-line
    },[editor])



    const handleImageCLick = (e:any)=>{

        let target = e.target as HTMLElement|null|undefined;

        if(!target||ClosestWithClass(target,"block-edit")!=null)
            return;


        if(target.tagName == "IMG"){

            let found = Quill.find(target);
            let index = (found)?editor.getIndex(found as any):0
            clickIndexRef.current = index;
            editor.setSelection(index,0);


            imgDom.current = target as HTMLImageElement;

            setEditorState(BlogEditorState.EditingImage);


        }

        else if((target.tagName == "A") && !target.classList.contains("v-button")){
            e.preventDefault();
            let found = Quill.find(target);
            let index = (found)?editor.getIndex(found as any):0

            clickIndexRef.current = index;
            scrollPoint.current = scrollRef.current.scrollTop;
            editor.setSelection(index,target.innerText.length);
            scrollRef.current.scrollTop = scrollPoint.current;
            SaveSelection();
            setEditorState(BlogEditorState.AddingLink);

        }

      }
    useEffect(()=>{

        document.addEventListener("mouseup",handleImageCLick);
        return ()=>{

            document.removeEventListener("mouseup",handleImageCLick);
        }
//eslint-disable-next-line
    },[]);

    // const HeaderOptions = [
    //     {label:"Normal",value:"0"},
    //     {label:"Heading 1",value:"1"},
    //     {label:"Heading 2",value:"2"},
    //     {label:"Heading 3",value:"3"},
    //     {label:"Heading 4",value:"4"},

    // ]

    let currentHeaderString = formats.header??"0"

    const align = (value: string) => {

        if (!editor) return;

        const selection = editor.getSelection();
        if (selection) {
          // Apply the alignment to the entire line containing the cursor/selection
          editor.formatLine(selection.index, selection.length, 'align', value || false);
        }
        updateFormats();

      };
    const execQuillCommand = (command: string, value?: any) => {

        if (!editor) return;

        const selection = editor.getSelection();

        if (selection) {
            const format = editor.getFormat(selection.index, selection.length);
            if (format[command]) {
                editor.formatText(selection.index, selection.length, command, false);
            } else {
                editor.formatText(selection.index, selection.length, command, value || true);
            }
        }
        updateFormats();
    }


        function bold(){
            execQuillCommand('bold');

        }

        function italic(){
            execQuillCommand('italic');

        }

        function underline(){
            execQuillCommand('underline');

        }

        function strikethrough(){
            execQuillCommand('strike');

        }

        function blockQuote(){

            if (!editor) return;

            const selection = editor.getSelection();
            if (selection) {
                let format = editor.getFormat(selection.index, selection.length);
                if(format.blockquote){
                    editor.format('blockquote', false);
                }
                else
                   editor.format('blockquote', true);
            }

            updateFormats();
           // execQuillCommand('blockquote');
        }

        function createUnOrderedList(){

            if(!editor)
                return;

            const selection = editor.getSelection();
            if (selection) {
               let format = editor.getFormat(selection.index, selection.length);

                if(format.list == "bullet" ){

                    editor.format('list', false);
                }
                else
                 editor.format('list', 'bullet');
            }

            updateFormats();

        }

        function createNumberedList(){

            if(!editor)
                return;

            const selection = editor.getSelection();
            if (selection) {
               let format = editor.getFormat(selection.index, selection.length);

                if(format.list == "ordered" ){

                    editor.format('list', false);
                }
                else
                 editor.format('list', 'ordered');
            }

            updateFormats();

        }


        function ClearFormatting(){

            if(!editor)
                return;
            const selection = editor.getSelection();
            if(selection)
            editor.removeFormat(selection?.index,selection?.length);

            updateFormats();
        }

        function Outdent(){

            if(!editor)
                return;

            const selection = editor.getSelection();
            if (selection) {

                const format = editor.getFormat(selection.index, selection.length);
                const currentIndent:any = format.indent || 0;
              editor.format('indent',currentIndent-1);
            }

            updateFormats();
        }
        function Indent(){

            if(!editor)
                return;
            const selection = editor.getSelection();
            if (selection) {

                const format = editor.getFormat(selection.index, selection.length);
                const currentIndent:any = format.indent || 0;
              editor.format('indent',currentIndent+1);
            }
            updateFormats();

        }

        function AlignCenter(){

            align("center");
            updateFormats();

        }
        function AlignLeft(){

            align("");
            updateFormats();
        }
        function AlignRight(){

            align("right");
            updateFormats();
        }

        const formatColor = (value:string) => {

            if(colorRef.current){

                let v = value;

                colorRef.current.style.background = v;

            }


                saveScroll();
                editor.format('color',value);
                loadScroll();
        }

        const convertToHeading = (level:number) => {

            if (!editor) return;

            const selection = editor.getSelection();
            if (selection) {
                let format = editor.getFormat(selection.index, selection.length);
                if(format.header == level){
                    editor.format('header', false);
                }
                else
                   editor.format('header', level);
            }

            updateFormats();
          };

            let clr = formats.color;
            if(clr && Array.isArray(clr))
                clr = clr[0];

            if(!clr)
                clr = "";
    return (

       <>    {editorState == BlogEditorState.PromptingAI&&<>
    <AIEditor

        onSelectAll={()=>{
            editor.setSelection(0,100000);
            currentSelectionRef.current = editor.getSelection();
            SaveSelection();

        }}
       rewriting={( (currentSelectionRef.current&&currentSelectionRef.current?.length>1||(dom&&dom.textContent&&dom.textContent.length>2))||siteData.designer?.state?.mode != EditorMode.Blogging)?true:false} rewriteFunc={rewriteSelectedContent} editor={editor} onClose={()=>setEditorState(BlogEditorState.Editing) }/></>}
       {(editorState == BlogEditorState.AddingLink||editorState == BlogEditorState.PickingColor||editorState == BlogEditorState.PromptingAI)&&
        <HighlightBlock  dom ={dom} editor={editor}  selectionRef={currentSelectionRef}/>
       }
            {editorState == BlogEditorState.AddingImage&&<TextEditorImagePopUp siteData={siteData} toggleLoading={setNomralLoading} onAddImage={(url:string)=>{
                insertImage(url);
            }} context={context} onClose={()=>setEditorState(BlogEditorState.Editing)}/>}
             {editorState == BlogEditorState.UpdatingImage&&<TextEditorImagePopUp siteData={siteData} toggleLoading={setNomralLoading} onAddImage={(url:string,data?:any)=>{


               if(imgDom.current){

                    imgDom.current.src = url;
                    let dom = imgDom.current.parentElement;
                    let nextDom = dom?.nextSibling;


                    if(nextDom && data){
                        let txt = nextDom.textContent??"";
                        if(txt.includes("Photo by")&&txt.includes("Unsplash")){
                            let a = (nextDom as HTMLElement).querySelector("a");
                            if(a){
                                let name = data?.user?.name??"unknown";
                                let url = data?.urls?.regular??"#";

                                a.innerHTML = "<em>"+name+"</em>";
                                a.href = url;
                            }
                        }
                    }


                    if(node && data){
                        node.content = editor.root.innerHTML;



                    }

                }

                setEditorState(BlogEditorState.Editing)

            }} context={context} onClose={()=>setEditorState(BlogEditorState.Editing)}/>}
        {editorState == BlogEditorState.EditingImage&&imgDom.current&&scrollRef.current&&<ImageEditor

        onUpdateImage={()=>{setEditorState(BlogEditorState.UpdatingImage)}}
        index={clickIndexRef.current} editor={editor} scrollRef={scrollRef.current} onExit={()=>setEditorState(BlogEditorState.Editing)} imageDom={imgDom.current}/>}

            {isLoading&&<AILoader/>}
            {loadComplete&&<AILoaderFinish/>}
            {nomralLoading&&<Loader/>}
          <div className="inline-editor-container w-full center-all">
            <div key={node?.id} className="inline-editor-bar block-edit  vanimation-fade-in-down no-delay relative" style={{fontFamily:"proxima-nova",fontSize:"16px"}}>
              {editorState==BlogEditorState.Editing && <style>
                    {`
                        .ql-editor a{
                        cursor: pointer;
                        pointer-events: all !important;
                        }
                      .ql-editor a  *{

                        pointer-events: none !important;
                        }
                    `
                    }
                </style> }
                <ToolbarButton selected={false} onClick={()=>{SaveSelection(); setEditorState(BlogEditorState.PickingColor)}}><ColorPickerIcon inRef={colorRef} color={clr}/>
             <HoverToolTip text="Color"/>

             </ToolbarButton>
            {fullOptions&&
                <>

                <select key={currentHeaderString} className="invisible-button font-bold text-align-center" defaultValue={currentHeaderString} onChange={(e)=>{convertToHeading(parseInt((e.target as HTMLSelectElement).value))}}>
                    <option value="0">Normal</option>
                    <option value="1">Heading 1</option>
                    <option value="2">Heading 2</option>
                    <option value="3">Heading 3</option>
                    <option value="4">Heading 4</option>
                </select>

                </>}
                <ToolbarButton selected={formats.bold == true} onClick={bold}><BoldIcon/><HoverToolTip forceAbove={true} text="Bold"/></ToolbarButton>
                <ToolbarButton selected={formats.italic == true} onClick={italic}><ItalicIcon/><HoverToolTip forceAbove={true} text="Italicize"/></ToolbarButton>
                <ToolbarButton selected={formats.strike == true} onClick={strikethrough}><StrikeThroughIcon/><HoverToolTip forceAbove={true} text="Strike Through"/></ToolbarButton>
                <ToolbarButton selected={formats.underline == true} onClick={underline}><UnderlineIcon/><HoverToolTip forceAbove={true} text="Underline"/></ToolbarButton>
                <ToolbarButton selected={formats.list=="bullet"} onClick={createUnOrderedList}><ULIcon/><HoverToolTip forceAbove={true} text="Unordered List"/> </ToolbarButton>
                <ToolbarButton selected={formats.list=="ordered"}onClick={createNumberedList}><OLIcon/> <HoverToolTip forceAbove={true} text="Ordered List"/> </ToolbarButton>
                <ToolbarButton onClick={Outdent}><OutdentIcon/> <HoverToolTip text="Outdent"/></ToolbarButton>
                <ToolbarButton onClick={Indent}><IndentIcon/> <HoverToolTip text="Indent"/></ToolbarButton>
                {fullOptions&&
                <>
                <ToolbarButton selected={!formats.align} onClick={AlignLeft}><TextAlignLeft/> <HoverToolTip forceAbove={true} text="Align Left"/></ToolbarButton>
                <ToolbarButton selected={formats.align == "center"}onClick={AlignCenter}><TextAlignCenter/> <HoverToolTip forceAbove={true} text="Align Center"/></ToolbarButton>
                <ToolbarButton  selected={formats.align == "right"}onClick={AlignRight}><TextAlignRight/> <HoverToolTip forceAbove={true} text="Align Right"/></ToolbarButton>
                <ToolbarButton  selected={formats.blockquote != undefined} onClick={blockQuote}><QuoteIcon/> <HoverToolTip forceAbove={true} text="Quote"/></ToolbarButton>
                </>
                }
                <ToolbarButton onClick={ClearFormatting}><DeleteIcon/> <HoverToolTip forceAbove={true} text="Clear Formatting"/></ToolbarButton>
                             <div></div>
                {includeLinking&& <ToolbarButton selected={formats.link!=undefined} onClick={()=>{SaveSelection(); setEditorState(BlogEditorState.AddingLink)}}><LinkIcon/><HoverToolTip forceAbove={true} text="Add a Link"/></ToolbarButton>
}
                {fullOptions&& <ToolbarButton onClick={()=>{SaveSelection();  setEditorState(BlogEditorState.AddingImage)}}><AddImageIcon/><HoverToolTip forceAbove={true} text="Add an Image"/></ToolbarButton>}
                {fullOptions&& <ToolbarButton addClass="vagaro-ai-bg" onClick={()=>{SaveSelection();  setEditorState(BlogEditorState.PromptingAI)}}><AISparkleIcon/><HoverToolTip forceAbove={true} text="Use AI"/></ToolbarButton>}
                {editorState == BlogEditorState.AddingLink&&<><LinkEditor
                dom={dom}
                selectionRef={currentSelectionRef}
                key={currentSelectionRef.current?.index}
                inLink={formats.link??""}
                onApply={(lnk:string)=>{
                    if(currentSelectionRef.current){

                        editor.setSelection(currentSelectionRef.current.index,currentSelectionRef.current.length);
                        editor.format('link',lnk);
                        updateFormats();
                    }
                    setEditorState(BlogEditorState.Editing)
                }}
                editor={editor} onExit={()=>{

                    if(currentSelectionRef.current){
                        saveScroll();
                        editor.setSelection(currentSelectionRef.current.index,currentSelectionRef.current.length);
                        loadScroll();

                    }
                    setEditorState(BlogEditorState.Editing)}} anchorDom={linkDom.current}/></>}
                {editorState == BlogEditorState.PickingColor&&<><ColorPicker siteData={siteData} inColor={clr??""} onChange={formatColor} onClose={()=>setEditorState(BlogEditorState.Editing) }/></>}

            </div>
            </div>
        </>
    )
}


// const AIRewriteChips = [
//     {label:"Professional",value:"Make this more professional"},
//     {label:"Casual",value:"Make this more casual"},
//     {label:"Energetic",value:"Make this more energetic"},
//     {label:"Spelling & Grammar",value:"Correct all spelling and grammar"},
//     {label:"Add Images",value:"Add images to this content"},
//     {label:"Add Emojis",value:"Add emojis to this content"},
//     {label:"Longer",value:"Make this longer"},
//     {label:"Shorter",value:"Make this more concise"},
// ]

// const AIContentChips = [
//     {label:"Blog Ideas",value:"Write a list of blog ideas related to my business"},

//     {label:"Write an Article",value:"Write a full blog article about a topic related to my business. Use headings and paragraphs. Insert images after each paragraph"},
// ]

const AIToneOptions = [
    {label:"Select a Tone of Voice",value:""},
    {label:"Professional",value:AITones.professional},
    {label:"Casual",value:AITones.casual},
    {label:"Uplifting",value:AITones.uplifting},
    {label:"Inspirational",value:AITones.insperation},
    {label:"Trendy",value:AITones.trendy},
    {label:"Caring",value:AITones.caring},
    {label:"Motivational",value:AITones.motivational},
    {label:"Energetic",value:AITones.energetic},


]

// function AIChip({onClick,chip}:{onClick:(val:string)=>void,chip:{label:string,value:string}}){

//     return <div
//     className="no-shrink"
//     onClick={()=>onClick(chip.value)}
//     style={{background:"#e7e7e7",padding:"6px 8px",borderRadius:"6px",margin:"2px",cursor:"pointer"}}
//     >{chip.label}</div>

// }


function AIEditor({editor,onClose,rewriteFunc,rewriting,onSelectAll}:{rewriting:boolean,editor:Quill,onClose:()=>void,rewriteFunc:(tone:string,prompt:string)=>void,onSelectAll:()=>void}){


    const inputRef = useRef<HTMLTextAreaElement>(null);
    const [isRewriting,setIsRewriting] = useState<boolean>(rewriting);
    const [toneState,setToneState] = useState<string>("");
    // const chips = (rewriting?AIRewriteChips:AIContentChips);

 return <ModalOverlay  >

 <DefaultModal onClose={onClose}>

    <>
    <div className="flex-row gap-med align-center" style={{marginBottom:"12px"}}><SparkleIcon/> <h5 style={{margin:0}} > Vagaro AI</h5></div>


    <div className="w-full flex-row justify-between align-end gap-large" style={{marginBottom:"16px",width:"600px",maxWidth:"50vw"}}>
    <div>
        <label style={{marginBottom:"4px"}} className="font-bold">{"Tone (Optional):"}</label>
        <div className="form-row"><SelectDropdown additionalStyle={{width:"350px",paddingRight:"10px"}} options={AIToneOptions} defaultValue={toneState} onChange={(val)=>setToneState(val) } /> </div>
    </div>
    <button style={{marginBottom:"8px"}} onClick={()=>{onSelectAll();inputRef.current&&inputRef.current.focus(); setIsRewriting(true);  }} className="w-button w-button-ghost">Select All Text</button>
    </div>
    <div style={{border:"1px solid #c7c7c7",borderRadius:"4px",marginBottom:"8px"}} >

    <textarea  placeholder={isRewriting? "Make this sound more...":"Write me a post about..."} ref={inputRef} style={{resize:"none",borderRadius:"4px",border:"none", padding:"6px 6px",width:"calc(100vw - 100px)",minWidth:"300px",maxWidth:"500px",height:"120px",marginBottom:"4px"}}></textarea>
   {/* <div className="flex-row flex-wrap" style={{overflow:"auto",maxWidth:"500px",padding:"4px"}}>
        {
            chips.map((chip,index)=><AIChip key={index} onClick={(val:string)=>{if(inputRef.current){inputRef.current.value = val}}} chip={chip}/>)

        }
   </div> */}
   </div>
    <div className="flex-row gap-med justify-end" style={{background:"#f7f7f7",borderTop:"1px solid #cdcdcd",borderRadius:"0 0px 8px 8px",margin:"8px 0 -12px -12px",width:"calc(100% + 24px)",padding:"12px"}}>
        <button className="w-button w-button-secondary" onClick={()=>onClose()}>Cancel</button>
        <button className=" vagaro-ai-bg" style={{minWidth:"140px"}} onClick={()=>{


            rewriteFunc(toneState, inputRef.current?.value??"" );onClose();}}>Apply</button>

    </div>
    </>


</DefaultModal>
</ModalOverlay>

}

 export function  TextEditorImagePopUp({siteData,context,onClose,onAddImage,toggleLoading}:{siteData:SiteData,context:UserContext,onClose:()=>void,onAddImage:(url:string,data?:any)=>void,toggleLoading:(loading:boolean)=>void}){

    const [imageState, setImageState] = useState<"None"|"Unsplash"|"Upload"|"Library">("None");

    let title:ReactNode = "Select an Image";
    if(imageState == "Unsplash"){
        title = <div className="flex-row align-center gap-med">Search Online Library  <PoweredByUnsplash/>
        </div>;
    }


    return <ModalOverlay onClickOutside={onClose} >

            <AutoSizeModal onClose={onClose}>
                <h4 style={{padding:"0px 12px 12px 12px",minWidth:(imageState=="Unsplash"?"500px":"200px")}}>{title}</h4>
                {imageState == "None"&&
                <div className="flex-row">
                    <BigButton onClick={()=>setImageState("Unsplash")} ><div className="flex-column justify-center h-full gap-med"><UnsplashIcon/> <span>Search Online</span> </div></BigButton>
                    <div className=" big-sqr-button" style={{
        padding:"0px",

    }}> <UploadImageBtn btnStyling={{width:"100%",height:"100%",background:"none",border:"none",outline:"none",display:"flex",justifyContent:"center",alignItems:"center"}} context={context} toggleLoading={toggleLoading} onImageUploaded={onAddImage} onFinish={onClose}/></div>
                    <BigButton onClick={()=>setImageState("Library")}><div className="flex-column gap-med">
                    <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColoFr" viewBox="0 0 512 512"><path d="M464 224c0-8.8-7.2-16-16-16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224zm-16-64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0zm-8-80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0z"/></svg>

                        From Library</div></BigButton>
                </div>
            }<div style={{height:"6px"}}></div>
            {imageState == "Unsplash"&&<UnsplashMenu userContext={context} onSelect={(url:string,img:any)=>{onAddImage(url,img);  onClose()}}/> }
            {imageState == "Library"&&<ImageLibraryWrapper siteData={siteData} onSelect={(url:string)=>{onAddImage(url);onClose();}}/>}

            {<div className="flex-row justify-end" style={{paddingTop:"12px"}}>

                 <button className="w-button w-button-secondary" onClick={()=>{
                    if(imageState=="None"){
                        onClose();
                    }
                    else
                    setImageState("None")}}>Cancel</button>
            </div>}
        </AutoSizeModal>
    </ModalOverlay>

}

function HighlightBlock({editor,selectionRef,dom}:{dom:HTMLElement,selectionRef:any,editor:Quill}){

    const padding = 3;
    let portal = dom.querySelector('.highlight-portal');
    if(!portal){
        portal = document.createElement('div');
        portal.className = "highlight-portal";
        dom.appendChild(portal);
    }
    const getBounds = ()=>{



        if(selectionRef.current){
            let bounds = editor.getBounds(selectionRef.current.index,selectionRef.current.length);

            return bounds;
        }
        else{
            return document.body.getBoundingClientRect();
        }

    }
    const bounds = getBounds();
    useEffect(()=>{
        editor.blur();
        return ()=>{
            portal?.remove();
        }
        //eslint-disable-next-line
    },[]);

    return <>

    {bounds&&   createPortal( <div style={{position:"absolute",top:bounds!.top-padding+"px",left:bounds!.left-padding + "px",width:bounds!.width+padding*2+"px",height:bounds!.height+padding*2+"px",background:"var(--outline-transparent)",border:"1px solid var(--outline-primary)",zIndex:4}}></div>,portal)}
    </>

}

 function LinkEditor({editor,onApply,inLink,selectionRef,dom}:{dom:HTMLElement,selectionRef:any,inLink:string,editor:Quill,anchorDom:HTMLAnchorElement|null,onApply:(lnk:string)=>void,onExit:()=>void}){

    const [isValid,setIsValid] = useState(inLink==""|| urlValidation.test(inLink));


    const toolRef = useRef<HTMLDivElement>(null);
    const currentLink = useRef<string>(inLink);

    const inputRef = useRef<HTMLInputElement>(null);

    const onClickOutside = (e:any)=>{
        if(toolRef.current){
            if(!toolRef.current.contains(e.target)&&(ClosestWithClass(e.target,"inline-editor-bar")==null)&&e.target.tagName!="A"){
                // if(onExit){
                //     onExit();
                // }
                onApply(currentLink.current);
            }
        }
    }

    const updateValidation = ()=>{
        if(inputRef.current){
            let val = inputRef.current.value;
            if(val.length>0)
                setIsValid(urlValidation.test(val));
            else
                setIsValid(true);
        }
    }

    useEffect(()=>{

        inputRef.current?.focus();
        inputRef.current?.select();
        document.addEventListener("click",onClickOutside);
        return ()=>{
            document.removeEventListener("click",onClickOutside);
        }


//eslint-disable-next-line
    },[]);


    return <div ref={toolRef} className="block-edit vanimation-fade-in no-delay center-all blog-toolbar align-stretch relative " style={{ boxShadow:"rgba(0, 0, 0, 0.133) 0px 2px 15px 4px",position:"absolute",right:0,top:"calc(100% + 2px)",borderRadius:"6px", zIndex:1200,background:"white",padding:"6px"}} >


        <div className="flex-column" style={{padding:"6px"}}>
            <label>URL:</label>
            <div className="flex-row gap-small">

                <input ref={inputRef} type='text' placeholder="https://..." defaultValue={currentLink.current}
                onKeyDown={(e)=>{
                    if(e.key == "Enter"){
                        setTimeout(()=>onApply(currentLink.current),10);
                    }
                }}
                onInput={(e)=>{
                    let val = (e.target as HTMLInputElement).value;
                    if(val.length>0){
                        if((val.length>4&&!val.startsWith("http"))||val.startsWith("www.")){
                            (e.target as HTMLInputElement).value = ("https://"+val).trim();
                            val =    (e.target as HTMLInputElement).value
                        }
                        else{
                            val = val.trim();
                            if(inputRef.current)
                                inputRef.current.value = val;
                        }

                    }
                    updateValidation();
                    currentLink.current = val;
                }} style={{padding:"6px",border:"1px solid #00000022",borderRadius:"4px"}}/>
            </div>
            {!isValid&&<div style={{color:"red",fontSize:"12px",padding:"6px",lineHeight:"6px",marginBottom:"-5px"}}>Invalid URL</div>}
            {/* <button className="w-button button-primary" style={{marginTop:"4px"}} onClick={()=>{   onApply(currentLink.current)}}>Save</button> */}
        </div>
            <button
            style={{position:"absolute",top:"4px",right:"4px"}}
        onClick={()=>onApply(currentLink.current)}
        ><XIcon/></button>
         </div>

}

 function ImageEditor({index,editor,onUpdateImage, imageDom,onExit,scrollRef}:{onUpdateImage:()=>void, index:number,editor:Quill,imageDom:HTMLImageElement,scrollRef:HTMLElement,onExit?:()=>void}){

    const applyCustomClass = (className:string) => {
        editor.setSelection(index,1);
   //     editor.format('cClass', className
        imageDom.className = className;

      };



    const space = 8;
    const offsetX = 0;
    const offsetY = 0;

    const toolRef = useRef<HTMLDivElement>(null);

    const [bounds,setBounds]  = useState<DOMRect|undefined>(imageDom.getBoundingClientRect());

    let top = 0;
    if(bounds)
        top = bounds.top;
    if(top<120)
        top = 120;



    const updateBounds = ()=>{
        let rect = imageDom.getBoundingClientRect();
        setBounds(rect);


    }

    const onscroll = (e:any)=>{
        updateBounds();
    };

    const onClickOutside = (e:any)=>{
        if(toolRef.current){
            if(!toolRef.current.contains(e.target)&&!imageDom.contains(e.target)){
                if(onExit){
                    onExit();
                }
            }
        }
    }

    useEffect(()=>{
        window.addEventListener("scroll",onscroll);
        scrollRef.addEventListener("scroll",updateBounds);
        window.addEventListener("resize",updateBounds);

        document.addEventListener("keydown",updateBounds);
        document.addEventListener("click",onClickOutside);
        return ()=>{
            scrollRef.removeEventListener("scroll",updateBounds);
            window.removeEventListener("scroll",onscroll);
            window.removeEventListener("resize",updateBounds);
            document.removeEventListener("keydown",updateBounds);
            document.removeEventListener("click",onClickOutside);
        }
//eslint-disable-next-line
    },[]);

    if(!bounds)
        return <></>;

    let size = "large";

    if(imageDom.classList.contains("small")){
        size = "small";
    }
    else if(imageDom.classList.contains("medium")){
        size = "medium";
    }

    const adjustSize = (size:string)=>{


        if(size.length>0){
            applyCustomClass(size);
            editor.setSelection(index,0);
        }


        updateBounds();
    }

    const updateAlt = (e:any)=>{
        imageDom.alt = e.target.value;
    }


    return <div ref={toolRef} className="block-edit vanimation-fade-in no-delay center-all  align-stretch relative " style={{ maxWidth:"220px", boxShadow:"rgba(0, 0, 0, 0.133) 0px 2px 15px 4px",position:"fixed",left:bounds.left+space+offsetX+"px",top:top+offsetY+space+"px",borderRadius:"6px", zIndex:1200,background:"white",padding:"6px"}} >
        <div className="flex-column  wb-input-group gap-small" style={{padding:"6px"}}>
            <div className="cont">
              <label>Size:</label>

                <div className="flex-row w-full wb-input-row">
                <button  className={(size=="small"?"selected ":" ")}
                    onClick={()=>{adjustSize("small")}}
                    >S</button>
                    <button className={(size=="medium"?"selected":" ")}
                    onClick={()=>{adjustSize("medium")}}
                    >M</button>
                    <button className={(size=="large"?"selected":"")}
                    onClick={()=>{adjustSize("large")}}
                    >L</button>


                </div>

        </div>

        <div className="cont">
            <label>Alt Text:</label>
            <div className="flex-row gap-small wb-input-row">

                <input type='text' placeholder="alt text" defaultValue={imageDom.alt} onInput={updateAlt} style={{padding:"6px",border:"1px solid #00000022",borderRadius:"4px"}}/>
            </div>
        </div>
        <div className="cont">
            <label>Update / Delete:</label>
        <div className="flex-row wb-input-row" style={{alignItems:"stretch",minHeight:"40px"}}>
            <button className="invisible-button w-full"  onClick={onUpdateImage}>
                <HoverToolTip text="Change Image"/>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 576 512"><path d="M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg></button>
            <button className="invisible-button w-full" onClick={()=>{

            if(imageDom.parentElement&&imageDom.parentElement.tagName == "span"){
                imageDom.parentElement.remove();
            }
            else
                imageDom.remove();

            onExit&&onExit();}}>
                   <HoverToolTip text="Delete Image"/>
                <DeleteIcon/></button>

        </div>
        </div>
        </div>
            <button
            className="invisible-button"
            style={{position:"absolute",top:"4px",right:"4px"}}
        onClick={onExit}
        ><XIcon/></button>
         </div>

}

 function ColorPicker({onChange,onClose,inColor,siteData}:{siteData:SiteData,inColor:string,onChange:(color:string)=>void,onClose:()=>void}){

    if(!inColor)
        inColor = "var(--default-font-color)";

    const onUpdate = (color:string)=>{
        onChange(color);

        if(!color||color==""||color.length<2){
           setTimeout( onClose,10);

        }
    }

    return <CustomColorPicker toggleOpen={onClose} siteData={siteData} inColor={inColor} changeFunc={onUpdate} top={50} left={220}/>

}

function ColorPickerIcon({color,inRef}:{color:string,inRef:any}){

    return <div  className="color-button-container" style={{overflow:"hidden",width:"26px",height:"26px",flexShrink:"0"}}>
        <div className="w-full h-full" ref={inRef} style={{background:color}}></div>
    </div>
}




 function UploadImageBtn({btnStyling, context,toggleLoading,onImageUploaded,onFinish}:{btnStyling:any,context:UserContext,toggleLoading:(loading:boolean)=>void,onImageUploaded:(url:string)=>void,onFinish:()=>void}){


    const afterValidation = (filename:any,base64:any)=>{
        toggleLoading(true);


        const onComplete = ()=>{ // disable loading on complete
            toggleLoading(false);
            if(onFinish){
                onFinish();
            }
        }

        const onSuccess = (data:any)=>{
           if(data ){

                const url = context.cdnURL +"Websitebuilder/"+ data;
                onImageUploaded(url);
                //insert the url
           }

        }

        const onError = ()=>{

            toggleLoading(false);
            AlertConfirm("Error Uploading Image, Please Try Again Later");
        }


        UploadImage(context,"Library_" + filename,base64,onSuccess,onError,onComplete,);

    }

    return   <button style={btnStyling} className="add-image-upload flex-column">
    <FileUpload

                height={3500}
                width={3500}
                allowFlexibleSize = {true}
                setLoading = {()=>{}}
                Message="Maximum Width and Height required 3500X3500"
                ValidFileExtensionMessage="Upload a PNG, or JPG"
                FileExtension="/(png|jpg|jpeg|PNG|JPG|JPEG)$/i"
                savecdn = {(filename:any,base64:any, height:any, width:any,fileDetails:any)=>{

                 ValidateImageDimensions(fileDetails,3500,3500,()=>{
                    afterValidation(filename,base64);
                 },(mess)=>{AlertConfirm(mess)});

                }}

    />
        <div  style={{fontSize:"22px",lineHeight:"1em",fontWeight:"700"}}></div><CloudUploadIcon/><div style={{height:"8px"}}></div><div>Upload Image</div></button>
}

function ImageLibraryWrapper({onSelect,siteData}:{siteData:SiteData, onSelect:(url:string)=>void} ){


    return <div className="flex-row flex-wrap align-start gap-med" style={{padding:"6px", minWidth:"420px",overflow:"auto",maxHeight:"420px"}}>
        {
            siteData.imageUrls.map((url:string)=>{

                return <button
                onClick={()=>{onSelect(url)}}
                key={url} className="invisible-button" style={{backgroundSize:"contain",backgroundPosition:"center",backgroundRepeat:"no-repeat",borderRadius:"4px",border:"1px solid #CDCDCD",backgroundColor:"#f7f7f7",backgroundImage:`url(${url})`,paddingBottom:"calc(33% - 4px)",width:"calc(33% - 4px)"}} ></button>
            })

        }

    </div>


}

function AddImageIcon(){
    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 512 512"><path d="M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>
}

function ToolbarButton({selected,onClick,children,addClass}:{selected?:boolean, onClick:()=>void,children?:ReactNode,addClass?:string}){

    let cls = addClass??"";
    return <button onClick={onClick} className={"btn relative invisible-button"+(selected?" selected ":" ")+cls}>{children}</button>
}

// function H1Icon(){

//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor"><path d="M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8 456 400l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-312z"/></svg>
// }
// function H2Icon(){

//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm397.3 40.8C457.9 118 474 112 490.7 112l9.2 0c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-162.6 0L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64l-9.2 0c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"/></svg>
// }
// function H3Icon(){

//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l142.1 0L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l88 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-72.6 0c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8l72.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-30.1 0L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64L400 64z"/></svg>}
// function H4Icon(){

//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M455.5 92.9L421.5 256 592 256l0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-200 0c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24l0 136 224 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152L48 272l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 248 0 88C0 74.7 10.7 64 24 64z"/></svg>
// }
function QuoteIcon() {

    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448 296c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-256 0c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72z"/></svg>
}

// function AiIcon(){
//    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#ffffff"><path d="M384 64L416 0l32 64 64 32-64 32-32 64-32-64L320 96l64-32zM128 192L192 64l64 128 128 64L256 320 192 448 128 320 0 256l128-64zM416 320l32 64 64 32-64 32-32 64-32-64-64-32 64-32 32-64z"/></svg>

// }

function AISparkleIcon(){

return <div className='ai-sparkle'>
        <SingleSparkler/>
        <SingleSparkler/>
        <SingleSparkler/>
     </div>

}

function SparkleIcon(){
  return  <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="#c643f4" viewBox="0 0 512 512"><path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"/></svg>
}

function SingleSparkler(){

    return <svg
    fill="#ffffff"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z"/></svg>

}

function ModalOverlay({children,onClickOutside}:{children:ReactNode,onClickOutside?:()=>void}){
   return <div  onClick={(e)=>{
    if(onClickOutside&&(e.target as HTMLElement).classList.contains("modal-overlay")){onClickOutside()}}}
     className="modal-overlay block-edit vanimation-fade-in no-delay w-full h-full center-all relative" style={{position:"fixed",left:"0",top:"0",zIndex:900,background:"rgba(0,0,0,.5)",padding:"16px 32px"}} >
        {children}
    </div>

}

function DefaultModal({children,onClose,styling}:{children:ReactNode,onClose?:()=>void,styling?:any}){






return   <div className="vanimation-fade-in-up no-delay flex-column relative" style={{padding:"12px",borderRadius:"6px",background:"white",boxShadow:"0 0 10px 20px #00000022",transition:".3s",...styling}} >

    {children}

    <button  className="invisible-button" style={{position:"absolute",top:"4px",right:"4px"}} onClick={onClose}><XIcon/></button>

</div>
}

function AutoSizeModal({children,onClose,styling}:{children:ReactNode,onClose?:()=>void,styling?:any}){

    const [width,setWidth] = useState(250);
    const [height,setHeight] = useState(0);

    const updateBounds = ()=>{



        if(domRef.current){

            setWidth(domRef.current.clientWidth+24);
            setHeight(domRef.current.clientHeight+24);
        }
    }

    useEffect(()=>{

        const observer = new ResizeObserver((entries)=>{
            updateBounds();
        });

        if(domRef.current){

            observer.observe(domRef.current);
        }

        updateBounds();
        window.addEventListener("resize",updateBounds);
        return ()=>{
            window.removeEventListener("resize",updateBounds);
        }
//eslint-disable-next-line
    },[]);


    const domRef = useRef<HTMLDivElement>(null);


    return   <div className="vanimation-fade-in-up no-delay flex-column relative" style={{width:`${width}px`,height:`${height}px`, padding:"12px",overflow:"hidden",borderRadius:"6px",background:"white",boxShadow:"0 0 10px 20px #00000022",transition:".3s",...styling}} >
         <div style={{position:"absolute",top:"0",left:"0",width:"80vw",height:"80vh"}}> {/*additional wrapper to account for internal using w-full or h-full*/}
            <div ref = {domRef} style={{position:"absolute",top:"12px",left:"12px", maxHeight:"calc(100vh - 100px)",maxWidth:"100vw - 100px",overflow:"auto"}}>
            {children}
        </div>
        </div>
        <button  className="invisible-button" style={{position:"absolute",top:"4px",right:"4px"}} onClick={onClose}><XIcon/></button>

    </div>
    }


function CloudUploadIcon(){
    return <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 640 512"><path d="M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"/></svg>
}

function BigButton({onClick,children,extraStyling}:{onClick:()=>void,children?:ReactNode,extraStyling?:any}){



    return <button onClick={onClick} className=" big-sqr-button" style={
extraStyling
    }>{children}</button>
}

export function GetReadTime(){
    let dom = document.getElementById("v-canvas");

    if(dom){
        let txt = dom.innerText??"";
        txt = txt.replaceAll("\n"," ").replaceAll("  "," ").replaceAll("  "," ").replaceAll("  "," ");
        let words = txt.split(" ").length;
        return Math.ceil(words/200);
    }

    return -1;
}
